/* eslint-env browser */
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const backendApi = createApi({
  baseQuery: fetchBaseQuery({ baseUrl: '/v1/' }),
  tagTypes: [],
  endpoints: (builder) => ({
    getMapData: builder.query<IMapLocation[], void>({
      query: () => 'https://aufind.au.dk/web/xmltojson.php?lang=1&getdepartments=false&getoverlays=false',
      transformResponse: (response: IMapResponse) => response.locations,
    }),
    searchPerson: builder.query<IEmployee[], string>({
      query: (payload: string) => `https://aufind.au.dk/searchPeople.php?q=${payload}&mode=json`,
    }),
  }),
});

export const {
  useGetMapDataQuery,
  useLazySearchPersonQuery,
} = backendApi;
